import { createStore, createLogger } from 'vuex'; 
import createPersistedState from 'vuex-persistedstate';

export default createStore({
    plugins: [createPersistedState(), createLogger()],
    state: {
        token: null,
        expiration: null,
        role: null,
        language: "id",
        captchaCount: 0
    },
    mutations: {
        setToken: (state, model) => {
            state.captchaCount = 0;
            state.token = model.user_data;
            state.expiration = model.token_expiry
            if(state.token.Language != null){
                state.language = state.token.Language;
            }
            //state.expiration = new Date()
        },
        clearToken: (state) => {
            state.token = null;
            state.expiration = null;
            //state.expiration = Date.now();
        },
        setRole: (state, model) =>{
            state.role = model;
        },
        setLanguage: (state, model)=>{
            state.language = model;
        },
        setCaptchaCount: (state) => {
            state.captchaCount++;
        }
    },
    getters: {
        isAuthenticated: (state) => {
            var currentToken = state.token;
            if (currentToken) {
                return true;
            }
            else return false;

            //return state.token != "" && state.expiration > Date.now();
        },
        authorizedMenu: (state) => {
            if (state.token) {
                return state.token.Menus;
            }
            else return null;
        },
        isExpired: (state) => {
            var currentToken = state.token;

            if (currentToken) {
                if (new Date(state.expiration) <= new Date()) {
                    return true;
                }
                else return false;
            } else return false;
        },
        getUsername: (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Employee_Number;
            }
            else return "";
        },
         getFullname: (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Full_Name;
            }
            else return "";
        },
        getRole : (state) =>{
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Role;
            }
            else return "";
        },
        getIsAdmin :(state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Is_Admin;
            }
            else return false;
        },
        getUseAD: (state) => {
            var currentToken = state.token;

            if(currentToken){
                return currentToken.Use_AD;
            }
            else return false;
        },
        getIsUser :(state) => {
            return checkRole(state, state.role.USER);
        },
        getIsTransporter :(state) => {
            return checkRole(state, state.role.TRANSPORTER);
        },
        getIsDriver :(state) => {
            return checkRole(state, state.role.DRIVER);
        },
        getIsCustomerVendor :(state) => {
            return checkRole(state, state.role.CUSTOMER) || checkRole(state, state.role.VENDOR);
        },
        getDepartment: (state) => {
            return state.token.Department;
        },
        getLanguage: (state) =>{
            return state.language;
        },
        getMenu: (state) => {
            return state.token ? state.token.Menus : [];
        },
        getCaptchaCount: (state) => {
            return state.captchaCount;
        }
    },
    actions: {
        login: async ({ commit }, data) => {
            commit("setToken", data);
        },
        logout: async ({ commit }) => {
            commit("clearToken");
        },
        role: async ({ commit }, data) => {
            commit("setRole", data);
        },
        language: async({commit}, data) =>{
            commit("setLanguage", data);
        },
        menu: async({commit}, data) => {
            commit("setMenu", data);
        },
        setCaptchaCount: async({commit}) => {
            commit("setCaptchaCount");
        }
    }
});

function checkRole(state, role){
    var currentToken = state.token;

    if (currentToken) {
        if(currentToken.Is_Admin) return true;
        else return currentToken.Role == role;
    }

    else return false;
}